<template>
  <div style="">
    <div class="container-fluid">
      <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
      <div class="row" v-if="!active">
        <div class="col-lg-4 col-12" style="background: #FEF6E3;">
        </div>
        <div class="col-lg-4 col-12" style="background: white; height: 100vh">
          <div class="login--wrap">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="login--logo">
                    <Logo />
                  </div>
                  <span class="head login--title">Welcome back</span>
                  <br />
                  <span class="head--sub">Sign in to your ContestCrate Account.</span>
                  <form class="login--form" method="post"  v-on:keyup.enter="login()">
                    <input class="input--text email login--input-bottom" type="email" v-model="email" placeholder="Email address" name="email" />
                    <input class="input--text password login--input-bottom" type="password"  v-on:keyup.enter="login()" v-model="password" placeholder="Password" name="password" />
                  </form>
                </div>

                <div class="col-12 mt-6">
                  <span class="form--error mb-4" v-for="error in errors" :key="error">
                    {{ error }}
                    <br />
                  </span>
                </div>

                <div class="col-lg-12 col-12 mt-6">
                  <button class="btn btn-primary login--button-main" @click="login">
                    Sign In
                  </button>
                  <router-link class-active="" class="" :to="{ name: 'register', params: { param: null } }">
                    <button class="btn btn-dark login--button-second">
                      Try ContestCrate
                    </button>
                  </router-link>
                  <div class="login--forgot">Forgot password.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-12" style="background: #FEF6E3;">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Logo from "../components/Logo";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    name: "login",
    components: {
      Loading,
      Logo,
    },
    data() {
      return {
        isLoading: false,
        fullPage: true,
        errors: [],
        email: null,
        password: null,
        active: false,
      };
    },
    methods: {
      keyUpEvent($event) {
        if ($event.keyCode === 13) {
          this.login();
        }   
      },
      login() {
        this.isLoading = true;
        var self = this;
        var email = this.email;
        var password = this.password;

        console.log("logging in");
        this.$store.dispatch('login', {
            email,
            password
          })
          .then(() => {

            console.log("logged in");
            self.$router.push('/');
            self.$globals.updateRepos();
            self.isLoading = false;
          })
          .catch(err => {
            console.log(err.response);
            self.errors = [];
            if (err.response.data.error) {
              self.errors.push(err.response.data.error);
            }
            if (err.response.data.email) {
              self.errors.push("Please fill in a valid email adress!");
            }
            if (err.response.data.password) {
              self.errors.push("Please fill in a valid password");
            }
            self.isLoading = false;
          })

        /*
      axios({
        method: "POST",
        crossdomain: true,
        headers: { "Content-Type": "Content-Type:application/json" },
        url: "https://api.contestcrate.com/user/login",
        data: {
          email: self.email,
          password: self.password,
        },
        body: {
          email: self.email,
          password: self.password,
        },
      })
        .then(function (response) {
          var zelf = self;
          localStorage.token = response.data.token;
          console.log(response);
          setTimeout(function(){     
            zelf.isLoading = false;
            zelf.$globals.updateRepos(); 
            zelf.$router.push("/");
          }, 400);
        })
        .catch(function (error) {
          self.errors = error.data;
          self.isLoading = false;
        });*/
      },

      register() {
        this.active = true;
      },
    },
  };
</script>